import { Navigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../hooks';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';

export const ProtectedRoute = ({ children, requiredRole }) => {
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(false);
  }, [user]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Verifica si el usuario está autenticado
  if (!user || !user.id) {
    return <Navigate to="/" />;
  }

  // Verifica el rol si es necesario
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/home" />;
  }

  // Renderiza el contenido protegido
  return children;
};
